module.exports = __webpack_public_path__ + "media/img/vca/sponsors/tbakery-ed4be0b81ba62c1740d1e70b51fcab78.png";